import React from "react";
import PropTypes from "prop-types";

function SavedGroupsLoadError({ error, onRetry, style = undefined }) {
  const message =
    error.source === "memberships" ? "Couldn't load which sources you've saved." : "Couldn't load your groups.";

  return (
    <div
      role="alert"
      style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "#b42318", ...style }}
    >
      <span style={{ flex: 1 }}>{message}</span>
      <button
        type="button"
        onClick={onRetry}
        style={{
          background: "none",
          border: "1px solid #d2d3d4",
          borderRadius: 6,
          padding: "2px 10px",
          fontSize: 12,
          color: "#394045",
          cursor: "pointer",
          flexShrink: 0,
        }}
      >
        Retry
      </button>
    </div>
  );
}

SavedGroupsLoadError.propTypes = {
  error: PropTypes.shape({ source: PropTypes.string }).isRequired,
  onRetry: PropTypes.func.isRequired,
  style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
};

export default SavedGroupsLoadError;
